import React from 'react'

import './styles.css'

import naturaIconHeader from '../../assets/logo-natura-white.svg';
import { Link } from 'react-router-dom';

const HeaderPublic = () => {
    return (
        <div className="header-public-container">
            <div className="header-public-content">
                <Link to="/">
                    <img className="header-public-icon" src={naturaIconHeader} />
                </Link>
            </div>
        </div>
    );
}

export default HeaderPublic;
